import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { NCFileBatchEvent } from '@v2/pages/common/components/NCFileBatchEvents/types';
import { getColorBasedOnMachineStatus, isWeb, machineStatusColorName } from '@helpers';
import i18n from 'i18n-js';
import { NC_FILE_STATUSES_FOR_UNIQUE_TRACE_EVENT } from '@v2/pages/common/components/NCFileBatchEvents/constants';
import Svg from '@styles/icons/svg';
import { NCFileBatchEventsProps } from '@v2/pages/common/components/NCFileBatchEvents';
import { BULLET } from '@v2/pages/common/constants/base.constants';

export interface EventStatusSubStatusExecModeProps extends Pick<NCFileBatchEventsProps, 'C' | 'scale' | 'font'> {
  includeExtraInfoBasedOnNCFileStatus?: boolean;
  displayStatusAsBadge?: boolean;
  withoutChevron?: boolean;
  event: NCFileBatchEvent;
}

const EventStatusSubStatusExecMode: FC<EventStatusSubStatusExecModeProps> = ({
  event,
  C,
  includeExtraInfoBasedOnNCFileStatus,
  displayStatusAsBadge,
  withoutChevron,
  scale = initialScale,
  font = initialFont,
}) => {
  const ncFileStatus = event?.ncFileStatus;

  const shouldDisplayAdditionalInfo =
    includeExtraInfoBasedOnNCFileStatus && ncFileStatus && NC_FILE_STATUSES_FOR_UNIQUE_TRACE_EVENT.includes(ncFileStatus);

  const badgeColor = C(`${getColorBasedOnMachineStatus(event.status)}`);

  return (
    <View style={[{ gap: scale(6), flexDirection: 'row', alignItems: 'center', flex: 1 }, !isWeb && { overflow: 'hidden' }]}>
      {shouldDisplayAdditionalInfo && (
        <>
          <Text style={[font.Footnote, { color: C('Label/Light/Tertiary') }]}>{i18n.t(`${ncFileStatus} NC File`)}</Text>
          <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>{BULLET}</Text>
        </>
      )}
      {displayStatusAsBadge ? (
        <View
          style={{
            height: scale(26),
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: scale(5),
            backgroundColor: badgeColor,
            borderRadius: scale(13),
            paddingHorizontal: scale(10),
          }}
        >
          <Text style={[font.Headline, { color: C('Label/Light/AlwaysLight Primary') }]}>{event.status}</Text>
          {!withoutChevron && (
            <Svg icon="chevronBottom" color="Label/Light/AlwaysLight Primary" width={scale(14)} height={scale(10)} transform="translate(0, 1)" />
          )}
        </View>
      ) : (
        <Text style={[font['Subhead 2'], { color: C(machineStatusColorName[event?.status]) }]}>{i18n.t(event?.status)}</Text>
      )}

      <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>{BULLET}</Text>
      <Text style={[font.Footnote, { color: C('Label/Light/Tertiary') }]}>{i18n.t(event?.subStatus)}</Text>
      {event?.executionMode && (
        <>
          <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>{BULLET}</Text>
          <Text style={[font.Footnote, { color: C('Label/Light/Tertiary') }]}>{i18n.t(event?.executionMode)}</Text>
        </>
      )}
    </View>
  );
};

export default EventStatusSubStatusExecMode;
